import { render, staticRenderFns } from "./QcSampleList.vue?vue&type=template&id=04f45534"
import script from "./QcSampleList.vue?vue&type=script&lang=js"
export * from "./QcSampleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports